<template>
	<div class="h-screen w-screen fixed top-0" style="z-index: 50;">
        <div @click="closePopup" class="w-full h-full fixed top-0 left-0 bg-grey-800 opacity-50"></div>
		
        <div class="fixed bottom-0 w-full px-5 md:px-10 lg:px-32 xl:px-64">
			<div class="w-full bg-green-90 md:rounded-t-lg h-auto max-h-full overflow-y-auto">
				<div class="flex flex-col max-h-screen overflow-hidden">
					<div class="flex -mb-3 pt-5 pb-3 px-5">
						<h1 class="flex-grow font-sans text-3xl sm:text-4xl m-0 -mt-2 pt-1 pb-2 text-green-700">{{ '@' + $parent.username }}</h1>
						
						<a @click="closePopup" @keypress.enter="closePopup" tabindex="0" class="block relative -mt-2 px-5 cursor-pointer">
							<svg xmlns="http://www.w3.org/2000/svg" class="block absolute" style="top: 50%; left: 50%; transform: translate(-50%, -50%); width: 40px; height: 40px;" viewBox="0 0 31 31" fill="none">
								<path d="M23.25 7.75L7.75 23.25" stroke="#2F493C" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
								<path d="M7.75 7.75L23.25 23.25" stroke="#2F493C" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
							</svg>
						</a>
					</div>
					
					<div class="overflow-y-auto px-5">
						<div v-if="error" class="px-10 mx-auto" style="max-width: 450px;">
							<illustration />
							
							<p class="mt-6 mb-8 px-1 font-body text-green-800 text-2xl leading-none text-center">
								{{ error }}
							</p>
						</div>
						<div v-else class="font-body text-green-1000 text-xl">
							<card :trip="trip" />
						</div>
					</div>
				</div>
            </div>
        </div>
	</div>
</template>

<script>
import PastTripDetails from '../components/PastTripDetails.vue';
import TripsIllustration from '../components/TripsIllustration.vue';

export default {
	name: 'PastTripPopup',
	props: ['trip', 'error'],
	components: {
		'card': PastTripDetails,
		'illustration': TripsIllustration
	},
	data() {
		return {
			user: {}
		}
	},
	created() {
		this.user = this.$parent.user;
		this.trip.force_include_code = true;
	},
	methods: {
		closePopup() {
			this.$parent.selected_trip = null;
			this.$router.push("/trips/" + this.$parent.username);
		}
	}
}
</script>